<template>
  <div class="developer">
    <TopNav :curTabProps="'2'"/>
    <el-row type="flex" justify="start" class="choose-date">
      <!-- <ChooseDate :dateValue.sync="dateValue" /> -->
      <ChooseDateAndCustomer :showCustomer="false" @paramsInfo="receiveParamsInfo" />
    </el-row>
    <el-row class="summary-row">
      <el-col :span="12">
        <div class="chart-summary">
          <!-- 圆环图表 -->
          <el-row style="height: 250px;" type="flex" justify="space-between">
            <div class="circle">
              <div>
                <p>{{pieInfo.todayOrderDuration}}</p>
                <p>服务时长</p>
                <p>(分钟)</p>
              </div>
            </div>
            <div class="circle">
              <div>
                <p>{{pieInfo.todayOrderCnt}}</p>
                <p>服务次数</p>
                <p>(次)</p>
              </div>
            </div>
            <div class="circle">
              <div>
                <p>{{pieInfo.todayActiveSnCnt}}</p>
                <p>激活平台数</p>
                <p>(个)</p>
              </div>
            </div>
            <div style="width: 250px;height: 200px">
              <PieChart :seriesRadiusProps="['55%', '70%']" :pieDataProps="pieArray" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="'内容类型次数占比'" />
            </div>
          </el-row>
          <el-row type="flex" justify="start">
            <div>终端使用分布分析</div>
          </el-row>
          <div style="width: 100%;height:300px;">
            <MapChart :mapData="mapData"/>
          </div>
          <!-- 下载图表 -->
          <div style="margin-top: 30px;">
            <TableForDownload
              :tableColumnsProps="mapTabColumns"
              :tableDataProps="pagination.paginationData"
              :themeColor="{color:'#F28639',colorOpa: 'rgba(242, 134, 57, 0.05)'}"/>
            <el-row type="flex" justify="center" v-if="pagination.total>0">
              <el-pagination
                @current-change="currentPageChange"
                layout="total, prev, pager, next"
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                v-bind:total="pagination.total">
              </el-pagination>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-summary">
          <div style="width: 100%;height:200px;margin-bottom: 50px;">
            <div v-if="JSON.stringify(companyActivityLine[0])==='[]'&&JSON.stringify(companyActivityLine[1])==='[]'">
              <el-empty style="width: 100%; height: 200px; margin-bottom: 50px;" description="暂无数据"></el-empty>
            </div>
            <LineChart v-else
              :lineDataProps="companyActivityLine" 
              :legendProps="legendProps"
              :axisNameProps="{xName: lineChartXName,yName: '/次'}" />
          </div>
          <el-row type="flex" justify="space-between">
            <div style="background:#A89700!important;">终端使用环境分析</div>
            <div class="tab-client">
              <span @click="tabChangeClick('浏览器')" :class="activeClientTab==='浏览器'?'active':''">浏览器</span>
              <span @click="tabChangeClick('系统')" :class="activeClientTab==='系统'?'active':''">系统</span>
              <span @click="tabChangeClick('设备')" :class="activeClientTab==='设备'?'active':''">设备</span>
            </div>
          </el-row>
          <!-- 柱状图 -->
          <div>
            <!-- 浏览器 -->
            <el-row v-if="activeClientTab==='浏览器'" type="flex" style="width: 100%;height:300px;">
              <el-col :span="8">
                <PieChart :seriesRadiusProps="['50%', '60%']" :pieDataProps="pieBrower" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="''" />
              </el-col>
              <el-col :span="16">
                <BarChart :barDataProps="browerBarData" />
              </el-col>
            </el-row>
            <div v-if="activeClientTab==='浏览器'" style="margin-top: 30px;">
              <TableForDownload
                :tableColumnsProps="browerTabColumns"
                :tableDataProps="browerTableDataProps"
                :themeColor="{color:'#A89700',colorOpa: 'rgba(168, 151, 0, 0.05)'}"/>
            </div>
            <!-- 系统 -->
            <div v-if="activeClientTab==='系统'">
              <div style="width: 100%;height:300px;">
                <BarChart :barDataProps="osBarData" />
              </div>
              <TableForDownload  style="margin-top: 30px;"
                :tableColumnsProps="osTabColumns"
                :tableDataProps="osTableDataProps"
                :themeColor="{color:'#A89700',colorOpa: 'rgba(168, 151, 0, 0.05)'}"/>
            </div>
            <!-- 设备 -->
            <div v-if="activeClientTab==='设备'">
              <div style="width: 100%;height:300px;">
                <BarChart :barDataProps="deviceBarData" />
              </div>
              <TableForDownload  style="margin-top: 30px;"
                :tableColumnsProps="deviceTabColumns"
                :tableDataProps="deviceTableDataProps"
                :themeColor="{color:'#A89700',colorOpa: 'rgba(168, 151, 0, 0.05)'}"/>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import TopNav from '../Components/topNav.vue'
// import ChooseDate from '../Components/chooseData.vue'
import TableForDownload from '../Components/tabeleFordownload.vue'
import BarChart from '@/components/chartComponents/bar.vue'
import MapChart from '@/components/chartComponents/map.vue'
import PieChart from '@/components/chartComponents/pie.vue'
import LineChart from '@/components/chartComponents/line.vue'
import ChooseDateAndCustomer from '../Components/chooseDataAndCustomer.vue'

export default {
  components: {
    TopNav,
    // ChooseDate,
    TableForDownload,
    BarChart,
    MapChart,
    PieChart,
    LineChart,
    ChooseDateAndCustomer
  },
  data() {
    return {
      dateValue: '',
      lineChartXName: '24小时',
      pieInfo: {
        todayOrderDuration: 0,
        todayOrderCnt: 0,
        todayActiveSnCnt: 0
      },
      pieArray: [],
      mapData: [],
      mapTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '地域'},
        {key: 'cnt',label: '服务次数'},
        {key: 'percent',label: '地域次数占比'},
      ],
      activeClientTab: '浏览器',
      browerTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '浏览器'},
        {key: 'cnt',label: '服务次数'},
        {key: 'percent',label: '占比'},
      ],
      osTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '系统'},
        {key: 'cnt',label: '服务次数'},
        {key: 'percent',label: '占比'},
      ],
      deviceTabColumns: [
        {key: '',label: '序号'},
        {key: 'prodType',label: '设备'},
        {key: 'cnt',label: '服务次数'},
        {key: 'percent',label: '占比'},
      ],
      mapTableDataProps: [],
      pagination: {
        paginationData: [],
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 活跃企业折线图- 第一个空数组用来放x轴
      companyActivityLine: [[]
        // ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        // [150, 230, 224, 218, 135, 147, 260],
        // [150, 230, 133, 218, 135, 17, 234],
      ],
      legendProps: [],
      pieBrower: [],
      browerTableDataProps: [],
      browerBarData: [[],[]],
      osTableDataProps: [],
      osBarData: [[],[]],
      deviceBarData: [[],[]],
      deviceTableDataProps: [],
      // *****************************************终端分析-new
      summaryParmasInfo: {// 查询终端分析需要的查询参数
        statUnit: 'currentDay',
      },
    }
  },
  watch: {
    'summaryParmasInfo': {
      handler(val) {
        this.resetData();
        this.getClientInfoSummary();
        this.getOrderSummaryAndSnCnt();
        this.getMapData();
        if(val.statUnit==='day' || val.statUnit==='currentDay') this.lineChartXName = '日';
        if(val.statUnit==='month') this.lineChartXName = '月';
        if(val.statUnit==='year') this.lineChartXName = '年';
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // this.getTodayAnalysis();
  },
  methods: {
    receiveParamsInfo(val) {
      console.log(val)
      this.summaryParmasInfo = val;
    },
    // 获取终端分析数据 - new 
    getClientInfoSummary() {
      let params = {
        ...this.summaryParmasInfo
      }
      this.getRequest('/dev/system/dvw/clientInfo/getClientInfoSummary', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          
          // 内容类型次数占比
          this.pieArray = data.prodInfo.map(item => {
            return {
              value: item.cnt,
              name: item.type
            }
          });
          
          // 不同类型使用时长趋势
          // 1.筛选出X轴数据
          data.prodInfoList.map(item => {
            item.cntAndDurationList.map(chiItem => {
              // X轴
              this.companyActivityLine[0].push(chiItem.type);
            })
          })
          // x轴去重
          this.companyActivityLine[0] = Array.from(new Set(this.companyActivityLine[0])).sort();
          // 2. X 轴固定，将缺少数据的数组，缺少的data填充为0
          data.prodInfoList.map(item => {
            let arr = [];
            this.companyActivityLine[0].map(xItem => {
              const I = item.cntAndDurationList.findIndex((cntItem) => cntItem.type === xItem);
               if( I !== -1) {
                arr.push(item.cntAndDurationList[I].cnt);
              } else {
                arr.push(0);
              }
            })
            
            this.companyActivityLine.push({
              name: item.prodType,
              type: 'line',
              data: arr,
              label:'-'
            })
            this.legendProps.push(item.prodType);
          })
          
          
           // **************************************************************终端使用环境分析-按浏览器统计
          let browerDurationTotal = 0;
          data.browserTypeInfo.map(item => {
            browerDurationTotal = this.cal.add(browerDurationTotal,Number(item.cnt));
            this.browerBarData[0].push(item.type);
            this.browerBarData[1].push(item.cnt)
          })
          // pie Brower
          this.pieBrower = data.clientTypeInfo.map(item => {
            return {
              value: item.cnt,
              name: item.type
            }
          });
          this.browerTableDataProps = data.browserTypeInfo.map(item => {
            let percent = browerDurationTotal? (Number(item.cnt)/browerDurationTotal*100).toFixed(2): 0;
            return Object.assign(item, {
              percent: percent? percent+'%': 0,
            })
          })
           // **************************************************************终端使用环境分析-按系统统计
          let osDurationTotal = 0;
          data.osVersionInfo.map(item => {
              osDurationTotal = this.cal.add(osDurationTotal,Number(item.cnt));
              this.osBarData[0].push(item.type);
              this.osBarData[1].push(item.cnt)
          })
          this.osTableDataProps = data.osVersionInfo.map(item => {
            let percent = osDurationTotal?(Number(item.cnt)/osDurationTotal*100).toFixed(2):0;
            return Object.assign(item, {
              percent: percent? percent+'%': 0,
            })
          })
          // **************************************************************终端使用环境分析-按设备统计 todayDurationByDevice
          data.deviceInfo.map(item => {
            this.deviceBarData[0].push(item.type);
            this.deviceBarData[1].push(item.cnt)
          })
          // console.log(data.todayTopClientDurationRegionInfo)
          // todayTopClientDurationRegionInfo
          // 列表
          let deviceTotal = 0;
          let firstArr = data.deviceInfoFilterByProd.map(item => {
            let total = 0;
            item.cntAndDurationList.map(chilItem => {
              deviceTotal = this.cal.add(deviceTotal,Number(chilItem.cnt));
              total = this.cal.add(total,Number(chilItem.cnt));
            })
            // itemTotal.push(total);
            return Object.assign(item,{cnt: total})
          })
          firstArr.forEach((item,index) => {
            let parPercent = deviceTotal?((Number(item.cnt)/deviceTotal)*100).toFixed(2):0;
            item.percent = parPercent+'%';
            item.cntAndDurationList.forEach(chilItem => {
              let percent = item.cnt?((Number(chilItem.cnt)/item.cnt)*100).toFixed(2):0;
              chilItem.percent = percent+'%'
            })
          })
          this.deviceTableDataProps = firstArr;

        }
      })
    },
    // 获取圆环数据 - new
    getOrderSummaryAndSnCnt() {
      let params = {
        ...this.summaryParmasInfo
      }
      this.getRequest('/dev/system/dvw/taskOrder/getOrderSummaryAndSnCnt', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          this.pieInfo = {
            todayOrderDuration: data.orderDuration || 0,
            todayOrderCnt: data.orderCnt || 0,
            todayActiveSnCnt: data.activeSnCnt || 0,
          }
        }
      })
    },
    // 获取终端分析-地图
    getMapData() {
      let params = {
        ...this.summaryParmasInfo,
        limitFlag: false
      }
      this.getRequest('/dev/system/dvw/clientInfo/getTopRegionSummary', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          // **************************************************************终端使用分布分析
          let mapDurationTotal = 0;
          this.mapData = data.topRegionSummary.map(item => {
            mapDurationTotal = this.cal.add(mapDurationTotal,Number(item.cnt));
            return {
              name: item.type,
              value: [parseFloat(item.lon).toFixed(4), parseFloat(item.lat).toFixed(4), parseFloat(item.cnt)]
            }
          })
          this.mapTableDataProps = data.topRegionSummary.map(item => {
            let percent = mapDurationTotal? (Number(item.cnt)/mapDurationTotal*100).toFixed(2): 0;
            return Object.assign(item, {
              percent: percent? percent+'%': 0,
            })
          })
          this.pagination.total = data.topRegionSummary.length;
          this.pagination.paginationData = this.mapTableDataProps.slice(0,this.pagination.pageSize+1);

        }
      })
    },
    resetData() {
      this.pieInfo = {
        todayOrderDuration: 0,
        todayOrderCnt: 0,
        todayActiveSnCnt: 0
      };
      this.pieArray = [];
      this.mapData = [];
      this.activeClientTab = '浏览器';
      this.mapTableDataProps = [];
      this.pagination = {
        paginationData: [],
        page: 1,
        pageSize: 10,
        total: 0
      };
      // 使用时长趋势
      this.companyActivityLine = [[]];
      this.pieBrower = [];
      this.browerTableDataProps =  [];
      this.browerBarData = [[],[]];
      this.osTableDataProps = [];
      this.osBarData = [[],[]];
      this.deviceBarData = [[],[]];
      this.legendProps = [];
      this.deviceTableDataProps = []
    },
    tabChangeClick(value) {
      this.activeClientTab = value;
    },
    currentPageChange(value) {
      this.pagination.page = value;
      let begin = (value - 1) * this.pagination.pageSize;
      let end = value * this.pagination.pageSize;
      this.pagination.paginationData = this.mapTableDataProps.slice(
          begin,
          end
      );
    },
  }
}
</script>
<style lang='scss' scoped>
 .developer {
   .choose-date {
     height: 39px;
     margin-top: 30px;
     margin-bottom: 50px;
     border-bottom: 1px solid #333;
     padding-bottom: 10px;
   }
  //  图表标题总结
  .summary-row {
    box-sizing: border-box;
    >div:nth-of-type(1) {
      padding-right: 100px;
      box-sizing: border-box;
    }
  }
  .chart-summary-right {
      box-sizing: border-box;
     >div:nth-of-type(1) {
       box-sizing: border-box;
       margin-bottom: 20px;
       >div:nth-of-type(1) {
         height: 100%;
        background: #FF6B00;
        border-radius: 10px;
        padding: 10px 15px;
        box-sizing: border-box;
        font-size: 20px;
        color:#fff;
        vertical-align: bottom;
       }
       >div:nth-of-type(2),
       >div:nth-of-type(3) {
         font-size: 14px;
         >i {
           display: inlie-block;
           font-size: 36px;
           border-bottom: 1px solid #000;
           font-weight: 600;
           padding: 5px 10px 0 10px;
         }
       }
     }
     >div:nth-of-type(2) {
       box-sizing: border-box;
     }
   }
   .chart-summary {
      box-sizing: border-box;
      .tab-client {
        height: 100%;
        >span{
          display: inline-block;
          padding: 10px ;
          margin: 0 10px;
          box-sizing: border-box;
          cursor: pointer;
        }
        >span.active {
          border-bottom: 2px solid #A89700;
          color: #A89700;
        }
      }
     >div:nth-of-type(2) {
       box-sizing: border-box;
       margin-bottom: 20px;
       >div:nth-of-type(1) {
         height: 100%;
        background: #F28639;
        border-radius: 10px;
        padding: 10px 15px;
        box-sizing: border-box;
        font-size: 20px;
        color:#fff;
        vertical-align: bottom;
       }
       >div:nth-of-type(2),
       >div:nth-of-type(3) {
         font-size: 14px;
         >i {
           display: inlie-block;
           font-size: 36px;
           border-bottom: 1px solid #000;
           font-weight: 600;
           padding: 5px 10px 0 10px;
         }
       }
     }
     >div:nth-of-type(3) {
       box-sizing: border-box;
     }
     .circle {
       text-align: center;
       width: 120px;
       height: 120px;
       border: 4px solid #FF6B00;
       border-radius: 50%;
       margin-top: 30px;
       >div {
         >p:nth-of-type(1) {
           color: #FF6B00;
           font-size: 22px;
           font-weight: 600;
           margin: 10px 0;
           margin-top: 35px;
         }
         >p:nth-of-type(2),
         >p:nth-of-type(3) {
           margin: 6px 0;
         }
       }
     }
   }
 }
 </style>
